import { render, staticRenderFns } from "./DrugFact.vue?vue&type=template&id=95626a4c&"
import script from "./DrugFact.vue?vue&type=script&lang=js&"
export * from "./DrugFact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports